// src/redux/actions/roleActions.js
import { SET_PERMISSIONS } from "./actionTypes";
 
export const setPermissions = (permissions) => ({
  type: SET_PERMISSIONS,
  payload: permissions,
});

 